import styled from "styled-components";

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-start;
  flex: 0 0 30%; /* take ~30% of row */
  min-width: 250px;

  @media (max-width: 992px) {
    flex: 1 1 100%;
    justify-content: center;
  }
`;

export const TablesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  margin-top: 2rem;

  div {
    width: 90%;
  }

  @media (max-width: 992px) {
    display: block;   /* ⬅️ disable flex on mobile */
    gap: 0;

    div {
      width: 100%;
      margin-bottom: 1.5rem; /* spacing between tables */
    }
  }
`